import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon, PlaneIcon, CalendarIcon } from 'lucide-react';
const FlightSearchForm = () => {
  const navigate = useNavigate();
  const [searchType, setSearchType] = useState('flight');
  const handleSubmit = e => {
    e.preventDefault();
    navigate('/search');
  };
  return <div className="text-left" data-id="element-14">
      <div className="flex space-x-4 mb-6" data-id="element-15">
        <button className={`px-4 py-2 rounded-md ${searchType === 'flight' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`} onClick={() => setSearchType('flight')} data-id="element-16">
          Flight Number
        </button>
        <button className={`px-4 py-2 rounded-md ${searchType === 'route' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`} onClick={() => setSearchType('route')} data-id="element-17">
          Route
        </button>
      </div>
      <form onSubmit={handleSubmit} data-id="element-18">
        {searchType === 'flight' ? <div className="mb-4" data-id="element-19">
            <label htmlFor="flightNumber" className="block text-gray-700 mb-2" data-id="element-20">
              Flight Number
            </label>
            <div className="relative" data-id="element-21">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-22">
                <PlaneIcon className="h-5 w-5 text-gray-400" data-id="element-23" />
              </div>
              <input type="text" id="flightNumber" placeholder="e.g. AA1234, DL5678" className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-24" />
            </div>
          </div> : <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-25">
            <div data-id="element-26">
              <label htmlFor="departure" className="block text-gray-700 mb-2" data-id="element-27">
                From
              </label>
              <input type="text" id="departure" placeholder="Airport or city" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-28" />
            </div>
            <div data-id="element-29">
              <label htmlFor="arrival" className="block text-gray-700 mb-2" data-id="element-30">
                To
              </label>
              <input type="text" id="arrival" placeholder="Airport or city" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-31" />
            </div>
          </div>}
        <div className="mb-4" data-id="element-32">
          <label htmlFor="date" className="block text-gray-700 mb-2" data-id="element-33">
            Date
          </label>
          <div className="relative" data-id="element-34">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-35">
              <CalendarIcon className="h-5 w-5 text-gray-400" data-id="element-36" />
            </div>
            <input type="date" id="date" className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-37" />
          </div>
        </div>
        <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-md transition-colors flex items-center justify-center" data-id="element-38">
          <SearchIcon className="h-5 w-5 mr-2" data-id="element-39" />
          Search Flights
        </button>
      </form>
    </div>;
};
export default FlightSearchForm;